<div class="auth">
  <!-- Fondo de Lealtad: retícula tenue y los dos resplandores de marca, verde
       arriba a la izquierda y rosa abajo a la derecha. -->
  <div class="auth__grid"></div>
  <div class="auth__glow auth__glow--green"></div>
  <div class="auth__glow auth__glow--pink"></div>

  <div class="auth__card auth__card--wide">
    <div class="auth__inner auth__inner--split">

      <div class="auth__side">
        <div class="auth__brand">
          <span class="auth__tag">BI de precios</span>
        </div>

        <div class="auth__body">
          <img src="assets/images/logo.png" alt="GASPRE" class="auth__logo" />
          <h1 class="auth__title">Bienvenido de vuelta</h1>
          <p class="auth__lede">Ingresa para ver el pulso de precios de tu red.</p>

          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
            <label class="auth-label" for="email">Correo</label>
            <div class="auth-field" [class.has-error]="submitted && f.email.errors">
              <input
                id="email"
                type="email"
                class="auth-input"
                formControlName="email"
                placeholder="operaciones@grupo.mx"
                autocomplete="email"
                [readonly]="loading"
                #emailInput
              />
              <span class="auth-check" *ngIf="emailValid" aria-hidden="true"><i class="fa fa-check"></i></span>
            </div>
            <p class="auth-error" *ngIf="submitted && f.email.errors">
              Ingresa un correo válido
            </p>

            <label class="auth-label" for="pwd">Contraseña</label>
            <div class="auth-field" [class.has-error]="submitted && f.password.errors">
              <input
                id="pwd"
                [type]="showPassword ? 'text' : 'password'"
                class="auth-input auth-input--secret"
                formControlName="password"
                placeholder="••••••••••"
                autocomplete="current-password"
                [readonly]="loading"
                #passwordInput
              />
              <span class="auth-divider"></span>
              <button
                type="button"
                class="auth-reveal"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
              >{{ showPassword ? 'Ocultar' : 'Ver' }}</button>
            </div>
            <p class="auth-error" *ngIf="submitted && f.password.errors">
              Ingresa tu contraseña
            </p>

            <div class="auth-row">
              <a href="javascript:void(0)" class="auth-link" (click)="recoverPassword()">Olvidé mi contraseña</a>
            </div>

            <!-- Sin [disabled]: el autocompletado del navegador llena los campos sin
                 avisarle a Angular, y un boton deshabilitado se traga el primer click.
                 onSubmit() valida y muestra los errores de abajo. -->
            <button type="submit" class="auth-cta" [class.is-loading]="loading" [attr.aria-busy]="loading">
              <ng-container *ngIf="!loading; else entering">
                <span>Iniciar sesión</span>
                <span class="auth-arrow" aria-hidden="true">→</span>
              </ng-container>
              <ng-template #entering>
                <span class="auth-spinner" aria-hidden="true"></span>
                <span>Entrando…</span>
              </ng-template>
            </button>
          </form>
        </div>
      </div>

      <!-- Panel animado de telemetría de precios; corre antes de autenticarse,
           así que todas sus cifras son sintéticas. -->
      <div class="auth__panel">
        <app-login-market></app-login-market>
      </div>

    </div>
  </div>
</div>
